module.exports = {
    nullTips: '用户名和密码不能为空',
    userName: '用户名',
    password: '密码',
    login: '登录',
    veriCode: '验证码',
    inputCodeTips: '请输入验证码',
    clickToRefresh: '点击刷新',
    INVALID_VERI_CODE: '验证码不正确',
    INVALID_USER_OR_PWD: '用户名或密码不正确'
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/i18n/locale.zh-cn.js
// module id = 4
// module chunks = 0